<template>
  <div class="newDataClass">
    <div class="leftDivClass">
        <h4 style="padding: 20px;padding-bottom: 0;">最新数据</h4>
        <span :class="activeIndex == index ? 'spanNameClass2' : 'spanNameClass'" v-for="(item,index) in dataObject" :key="index"  @click="changeTypeItem(item, index)">
          <img :src="activeIndex == index ? item.img1 : item.img2" />
          {{item.name}}
        </span>
    </div>
    <div class="rightDivClass">
      <div class="titleClass">
        <router-link to="/moonSampleHome">首页 / </router-link>
        <span>最新数据 / </span>
        <span @click="currentItem = ''">{{currentTypeValue}}</span>
        <span v-show="currentItem" style="color: #3a8ee6;"> / {{currentItem}}</span>
      </div>
   
      <div class="titleContentClass" v-if="activeIndex == 0">
        <div class="titleNameClass" v-show="!currentItem" v-for="(item, index) in newArrList" :key="index" @click="changeItemFunc(item)">
            <span><i class="el-icon-caret-right"></i>{{item.title}}</span>
            <span>{{item.createTime}}</span>
        </div>
        <div v-show="currentItem" class="infoDivClass">
            <h1 class="title1Class">{{currentObj.title}}</h1>
            <h2 class="title2Class">发布时间：{{currentObj.createTime}}   浏览次数：{{currentObj.views}}</h2>
            <ul class="contentClass">
              <li v-html="currentObj.content"></li>
            </ul>
        </div>
      </div>
      <div class="titleContentClass" v-else>
        <div class="titleNameClass" v-show="!currentItem" v-for="(item, index) in noticeArrList" :key="index" @click="changeItemFunc(item)">
            <span><i class="el-icon-caret-right"></i>{{item.title}}</span>
            <span>{{item.createTime}}</span>
        </div>
         <div v-show="currentItem" class="infoDivClass" >
            <h1 class="title1Class">{{currentObj.title}}</h1>
            <h2 class="title2Class">发布时间：{{currentObj.createTime}}    浏览次数：{{currentObj.views}}</h2>
            <ul class="contentClass">
              <li v-html="currentObj.content"></li>
            </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    components:{
    },
    data(){
      return{
        currentObj:{},
        noticeArrList:[],
        newArrList:[],
        currentTypeValue:"",
        currentItem:'',
        activeIndex:0,
        dataObject:[
          {img1:require('./../../assets/moonsamples/编号1.png'), img2:require('./../../assets/moonsamples/编号2.png'), name:'数据发布'},
          {img1:require('./../../assets/moonsamples/流程还1.png'), img2:require('./../../assets/moonsamples/流程还2.png'), name:'通知公告'}
        ]
      }
  },
  mounted(){
    this.currentItem = ''
    this.currentTypeValue = ''
    if(this.$route.query.type == 'new'){
      this.currentTypeValue = '数据发布'
      this.activeIndex = 0
    }else if(this.$route.query.type == 'notice'){
      this.currentTypeValue = '通知公告'
      this.activeIndex = 1
    }
    if(this.$route.query.param){
      this.changeItemFunc(this.$route.query.param)
    }
    this.initDataFunc()
  },
  methods:{
    homePageFunc(){
      this.$router.replace({ path: '/moonSampleHome'});
    },
    changeTypeItem(item, index){
      this.activeIndex = index
       this.currentTypeValue = item.name
       this.currentItem = ''
    },
    changeItemFunc(item){
      this.currentItem = item.title
      this.currentObj = item
    },
    async initDataFunc(){
			let res = await this.$http.get(this.$const.moonSample.getMoonSampleNewList);
			if (res && res.code==200) {
        this.noticeArrList = []
        this.newArrList = []
        // 新闻资讯类型;1:数据发布,2:动态新闻,3:最新成果,4:通知公告,5:其他
        res.rows.forEach(element => {
            if(element.newsType == 1){
                this.noticeArrList.push(element)
            }else if(element.newsType == 2){
                this.newArrList.push(element)
            }
        });
			}
    },
  }
}
</script>

<style lang="scss" scoped>
.newDataClass{
    width: 1200px;
    height: auto;
    margin: 0 auto;
    margin-top: 20px;
    min-height: 500px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    .leftDivClass{
        width: 240px;
        background-color: #ffffff;
      .spanNameClass, .spanNameClass2{
        cursor: pointer;
        height: 40px;
        font-family: MicrosoftYaHeiUI;
        font-size: 18px;
        color: #333333;
        display: flex;
        font-style: normal;
        align-items: center;
        line-height: 40px;
        padding-top: 20px;
        padding-left: 20px;
        img{
          padding-right: 10px;
        }
      }
      .spanNameClass2{
        color: #2A8EEC;
      }
    }
    .rightDivClass{
        display: flex;
        width: 940px;
        flex-direction: column;
        background-color: #fff;
        height: auto;
        padding: 20px;
        .titleClass{
          height: 40px;
          line-height: 40px;
          color: #000;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
        }
        .titleContentClass{
          display: flex;
          flex-direction: column;
          // width: 1350px;
          .titleNameClass{
              display: flex;
              padding: 20px;
              // width: 864px;
              height: 54px;
              font-family: MicrosoftYaHeiUI;
              font-size: 14px;
              color: #333333;
              letter-spacing: 0;
              font-weight: 400;
              justify-content: space-between;
              border-bottom: 1px solid #eeeeee;
              cursor: pointer;
          }
          .titleNameClass:hover{
              background: rgba(21,65,140,0.08);
              font-family: MicrosoftYaHeiUISemibold;
              font-size: 14px;
              color: #15418C;
              letter-spacing: 0;
              font-weight: 600;
          }
          .infoDivClass{
            padding: 20px;
            .title1Class,.title2Class{
              text-align: center;
       
            }
            .title2Class{
              color: #999;
              font-size: 12px;
              margin-top: 10px;
              text-align: center;
              margin-bottom: 10px;
            }
            .contentClass{
              font-family: MicrosoftYaHeiUI;
              font-size: 18px;
              color: #333333;
              line-height: 38px;
              text-align: left;
              font-style: normal;
              text-indent: 2em;
            }
          }
      }
    }
}
</style>>
